import React from "react";
/** @jsx jsx */
import { jsx } from "theme-ui";
import { Flex, Heading, Text, Badge } from "../core";
import { Location } from "../svg";
import moment from "../../helpers/moment";
import { Card } from "../Card";

const CardContent = React.forwardRef(
  ({ type, numero, date, title, place }, ref) => {
    const dateIsAfter = moment(date, "DD MMMM YYYY").isAfter();
    const dateIsSame = moment(date).isSame(moment(), "day");

    return (
      <Card.Content
        positions={["flex-start", "flex-start"]}
        sx={{ px: 3, paddingTop: 4, paddingBottom: 3 }}
      >
        {type === "Ponctuel" && (dateIsAfter || dateIsSame) ? (
          <Badge sx={{ position: "absolute", zIndex: 3, left: "12px", top: 2 }}>
            {dateIsAfter ? "À venir" : "Ce jour"}
          </Badge>
        ) : null}
        {type === "Permanent" ? (
          <Badge sx={{ position: "absolute", zIndex: 3, left: "12px", top: 2 }}>
            Inscris-toi
          </Badge>
        ) : null}
        {numero ? (
          <Badge
            sx={{
              position: "absolute",
              zIndex: 3,
              right: "12px",
              top: 2,
              backgroundColor: "secondary",
              py: "4px",
              lineHeight: " 24px",
            }}
          >
            #{numero}
          </Badge>
        ) : null}
        <Text variant="h6" color="primary" uppercase>
          {type === "Permanent" ? "Toute l’année" : date}
        </Text>
        <Heading
          as="h3"
          color="secondary"
          sx={{ marginTop: 1, marginBottom: 2 }}
        >
          {title}
        </Heading>
        <Flex>
          <Location />
          <Text fontWeight="semiBold" sx={{ marginLeft: 1, opacity: 0.7 }}>
            {place}
          </Text>
        </Flex>
      </Card.Content>
    );
  }
);

export { CardContent };
